<template>
  <div class="dashboard-container">
    <Grouptop/>
    <!-- <component :is="currentRole" /> -->
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import Grouptop from './admin/Grouptop'
// import editorDashboard from './editor'

export default {
  components: {
    Grouptop
  },
  name: 'Dashboard',
  data () {
    return {
      currentRole: 'adminDashboard'
    }
  }
//   computed: {
//     ...mapGetters([
//       'roles'
//     ])
//   },
//   created () {
//     if (!this.roles.includes('admin')) {
//       this.currentRole = 'editorDashboard'
//     }
//   }
}
</script>
<style lang="less" scoped>
.dashboard-container{
  padding: 32px
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/index.vue